import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Select } from "antd";
import useOtpHook from "../../../../Hooks/useOtpHook";
import {
  addBenificiaryxPay,
  getDmtBanks,
  verifyBankAccount,
  verifyBenificiary,
  XpressPayoutOtp,
} from "../../../../ApiServices/Apifun";
import {
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
  ifscPattern,
} from "../../../../Utils";
import CommonInput from "../../../../Common/CommonInput";
import { EkoverifyBank, getEkoBanks } from "../EkoEndpoint";
import { CheckCircleOutlined } from "@ant-design/icons";

const AddBeneFiciaryModalEkoxPay = ({
  isOpen,
  setIsOpen,
  handleSearch,
  mobile,
  type,
  selecteddata,
  from,
  setFrom,
}) => {
  const formref = useRef();
  const [form] = Form.useForm();
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [banks, setBanks] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [verifyBtnLoading, setVerifyBtnLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [selectLoading, setselectLoading] = useState(false);
  const handleOk = () => {
    setIsOpen(false);
  };
  const [bankVerifyStatus, setBankVerifyStatus] = useState(false);
  const [pendingFormValues, setPendingFormValues] = useState(null);
  const [verifyPinScreen, setverifyPinScreen] = useState(false);

  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(6);
  const handleCancel = () => {
    setIsOpen(false);
  };
  //  const handleGetbank = () => {
  //     getEkoBanks()
  //       .then((res) => {
  //         setBanks(
  //           res.banks.map((i) => {
  //             return {
  //               label: i?.bank_name,
  //               value: i?.id,
  //             };
  //           })
  //         );
  //       })
  //       .catch((err) => console.log(err));
  //   };
  const getAllBanks = () => {
    setselectLoading(true);
    getEkoBanks()
      .then((res) => {
        if (res.status) {
          setBanks(
            res.banks.map((i, index) => {
              return {
                label: i.bank_name,
                value: i.id,
                key: i.id,
                title: i?.bank_ifsc ? i.bank_ifsc : "",
              };
            }),
          );
          setselectLoading(false);
        } else {
          setBanks([]);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setselectLoading(false));
  };
  useEffect(() => {
    getAllBanks();
  }, []);

  // useEffect(() => {
  //   if (from === "edit" && selecteddata) {
  //     form.setFieldsValue({
  //       id: selecteddata.id,
  //       account_id: selecteddata.account_id,
  //       ifsc: selecteddata.ifsc,
  //       bank_id: selecteddata.bank_id,
  //       beneficiary: selecteddata.beneficiary,
  //       type: selecteddata.type,
  //       remitter: selecteddata.remitter,
  //     });
  //   }
  // }, [selecteddata, from, pendingFormValues]);

  useEffect(() => {
    if (from === "edit" && selecteddata && banks?.length) {
      const selectedBank = banks.find((b) => b.value === selecteddata.bank_id);
      setBankVerifyStatus(selecteddata.is_verified === "1");
      form.setFieldsValue({
        id: selecteddata.id,
        account_id: selecteddata.account_id,
        ifsc: selecteddata.ifsc,
        bank_id: selectedBank,
        beneficiary: selecteddata.beneficiary,
        type: selecteddata.type,
        remitter: selecteddata.remitter,
      });
    }
  }, [selecteddata, from, banks]);

  const handleAdd = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("mobile_number", mobile);
    formdata.append("type", type);
    formdata.append("account_id", val.account_id);
    formdata.append("pin", val.pin);
    formdata.append("bank_id", val.bank_id.value);
    formdata.append("beneficiary", val.beneficiary);
    formdata.append("ifsc", val.ifsc);
    // formdata.append("is_verified", bankVerifyStatus ? 1 : 0);
    formdata.append("is_verified", val.is_verified ? 1 : 0);

    addBenificiaryxPay(formdata)
      .then((res) => {
        if (res.status) {
          setIsOpen(false);
          handleSearch();
          setResponse(res.data.beneficiaries);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const handleEdit = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("id", selecteddata.id);
    formdata.append("mobile_number", mobile);
    formdata.append("type", type);
    formdata.append("account_id", val.account_id);
    formdata.append("pin", val.pin);
    formdata.append("bank_id", val.bank_id.value);
    formdata.append("beneficiary", val.beneficiary);
    formdata.append("ifsc", val.ifsc);
    formdata.append("is_verified", val.is_verified ? 1 : 0);
    // formdata.append("is_verified", bankVerifyStatus ? 1 : 0);

    console.log(bankVerifyStatus, "bankVerifyStatus");
    addBenificiaryxPay(formdata)
      .then((res) => {
        if (res.status) {
          setIsOpen(false);
          handleSearch();
          setResponse(res.data.beneficiaries);
        } else {
          setIsOpen(false);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  console.log(response, "response");
  const handleVerify = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("otp", pin.join(""));
    // formdata.append("otp_refrence_id", response.referenceKey);
    // formdata.append("remitter_mobile", mobile);
    // formdata.append("beneficiary_id", response?.beneficiaries);
    XpressPayoutOtp()
      .then((res) => {
        if (res.status) {
          setIsOpen(false);
          dispatchtoast("Beneficiery added successfully!");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const handlefillIFSC = (val, name) => {
    formref.current.setFieldsValue({
      ifsc: val.title,
    });
  };
  const handleVerifyBank = () => {
    setVerifyBtnLoading(true);
    const fieldValues = form.getFieldsValue();
    const formdata = new FormData();
    formdata.append("benificiary_account", fieldValues.account_id);
    formdata.append("benificiary_ifsc", fieldValues.ifsc);
    formdata.append("benificiary_name", fieldValues.beneficiary);
    formdata.append(
      "bank_id",
      fieldValues.bank_id?.value
        ? fieldValues?.bank_id?.value
        : fieldValues?.bank_id,
    );
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    EkoverifyBank(formdata)
      .then((res) => {
        if (res.status) {
          setBankVerifyStatus(true);
          dispatchtoast(res.message);
          formref.current.setFieldsValue({
            beneficiary: res.data.beneficiary_name,
            is_verified: true,
          });
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setVerifyBtnLoading(false));
  };
  console.log(bankVerifyStatus, "bankVerifyStatus");
  const isVerified =
    bankVerifyStatus !== null
      ? bankVerifyStatus
      : selecteddata?.is_verified === "1";
  return (
    <>
      <Modal
        title={`${
          showOtpScreen
            ? "Verify OTP"
            : from === "add"
              ? "Add Beneficiary"
              : "Edit Beneficiary"
        }`}
        footer={null}
        className="shadow-normal flex justify-normal items-center"
        width={300}
        maskClosable={false}
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {!showOtpScreen ? (
          <Form
            name="basic"
            form={form}
            ref={formref}
            initialValues={{
              remember: true,
            }}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(values) => {
              from === "add" ? handleAdd(values) : handleEdit(values);
            }}
            onValuesChange={() => {
              setBankVerifyStatus(false);
            }}
          >
            <Form.Item
              name={`account_id`}
              label={"Account Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Fill Account Number!",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Account Number"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`bank_id`}
              label={"Select Bank"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select One Bank!",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a bank"
                filterOption={filterOption}
                className="w-full mt-2"
                labelInValue
                onChange={(val, name) => handlefillIFSC(val, name)}
                loading={selectLoading}
                options={banks}
              />
            </Form.Item>
            <div className="grid grid-cols-3 place-items-center gap-2 m-2">
              {type === "Bank" ? (
                <Form.Item
                  name={`ifsc`}
                  label={"IFSC"}
                  className="col-span-2"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Enter IFSC Code!",
                    },
                    {
                      pattern: ifscPattern,
                      message: "Invalid ifsc number format!",
                    },
                  ]}
                >
                  <CommonInput
                    onInput={(e) => {
                      const value = e.target.value.toUpperCase();
                      e.target.value = value;
                    }}
                    placeholder="Enter IFSC Code"
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  name={`ifsc`}
                  label={"IFSC"}
                  className="col-span-2"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Enter IFSC Code!",
                    },
                    {
                      pattern: ifscPattern,
                      message: "Invalid ifsc number format!",
                    },
                  ]}
                >
                  <CommonInput
                    onInput={(e) => {
                      const value = e.target.value.toUpperCase();
                      e.target.value = value;
                    }}
                    placeholder="Enter IFSC Code"
                  />
                </Form.Item>
              )}
              <Button
                loading={verifyBtnLoading}
                onClick={() => handleVerifyBank()}
                className="bg-primary mt-4 p-3 w-full text-xs flex justify-center items-center outline-none border-none  text-white  rounded-md"
              >
                Verify Bank
              </Button>
              {isVerified && (
                <span style={{ color: "#52c41a", fontWeight: 500 }}>
                  <CheckCircleOutlined style={{ marginRight: 6 }} />
                  Verified
                </span>
              )}
            </div>
            <Form.Item name="is_verified" hidden>
              <input type="hidden" />
            </Form.Item>
            <Form.Item
              name={`beneficiary`}
              label={"Account Holder Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter account holder name!",
                },
              ]}
            >
              <CommonInput placeholder="Enter account holder name" />
            </Form.Item>{" "}
            <Form.Item
              name={`pin`}
              label={"Pin"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Pin To Validate!",
                },
                {
                  min: 4,
                },
              ]}
            >
              <CommonInput placeholder="Enter Pin" maxlength={4} />
            </Form.Item>{" "}
            <Form.Item
              className="w-full"
              //   wrapperCol={{
              //     offset: 8,
              //     span: 16,
              //   }}
            >
              <Button
                htmlType="submit"
                loading={btnLoading}
                className="bg-primary p-3 w-full flex justify-center items-center outline-none border-none  text-white  rounded-md"
              >
                {from === "add" ? "Add" : "Edit"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="  rounded-3xl shadow-normal bg-white p-5">
            <div className="header flex flex-col justify-center items-center">
              <p className="text-[15px] mt-3 text-gray-500">Enter PIN</p>
            </div>
            <div className=" mt-5 flex justify-center items-center">
              {[1, 2, 3, 4, 5, 6].map((i, index) => {
                return (
                  <input
                    key={index}
                    ref={inputRefs[index]}
                    type="text"
                    maxLength={1}
                    className="w-[25px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb bg-gray-100 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                    value={pin[index]}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyUp={(e) => handleKeyUp(index, e)}
                  />
                );
              })}
            </div>
            <Button
              loading={btnLoading}
              onClick={() => pin.length === 6 && handleVerify()}
              className={`SignInBtn w-full ${
                pin.length === 6 ? "cursor-pointer" : "cursor-not-allowed"
              }  mt-4 ${
                pin.length === 6 ? "bg-primary" : "bg-bsgray"
              }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
            >
              <p>Verify OTP</p>
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AddBeneFiciaryModalEkoxPay;
